module.exports = __webpack_public_path__ + "img/logo12.08e1a465.png";